import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { ENTITLEMENTS, ENTITLEMENT_LABELS } from '../application-core/constants';
import { ENTITLEMENTS as APPENTITLEMENTS } from '../core/utils/constants';
import BasicChip from '../core/BasicChip';
import { globalStyles as styles } from './style/gstheme';

class EntitlementWarning extends React.Component {

  render() {

    const { requiredEntitlements, compact, message, needAll, border } = this.props;
    const allEntitlements = Object.assign({}, ENTITLEMENTS, APPENTITLEMENTS);

    return (
      <div
        data-test="entitlement-warning"
        style={{
          textAlign: 'center',
          backgroundColor: 'white',
          ...(border) && { border: 'solid 1px black', borderRadius: 4, paddingTop: 12 },
          color: 'black',
          width: '100%',
          marginTop: compact ? 0 : 30
        }}>
        <Typography variant="body2">{message}</Typography>
        <Typography variant="body2" paragraph>You need {needAll === false && <span>one of</span>} the following entitlements. Please consult with your administrator.</Typography>
        {requiredEntitlements && requiredEntitlements.map((ent, index) => {
          const key = Object.keys(allEntitlements).find(key => allEntitlements[key] === ent);
          return <BasicChip
            dataTest={"ent-" + index}
            title="E"
            key={index}
            label={ENTITLEMENT_LABELS[key] || ent}
          />;
        })}
      </div>
    );
  }
}

EntitlementWarning.defaultProps = {
  compact: false,
  needAll: true,
  border: false,
  message: "You do not have permissions to access this area of the application."
};

EntitlementWarning.propTypes = {
  classes: PropTypes.object,
  compact: PropTypes.bool,
  needAll: PropTypes.bool,
  border: PropTypes.bool,
  message: PropTypes.string,
  requiredEntitlements: PropTypes.array
};

export default withStyles(styles)(EntitlementWarning);